import { Autocomplete } from "@mui/material";
import { styled } from "@mui/material/styles";
import downArrow from "../../../../Assets/Images/downArrow.png";

/**
 * StyledAutocomplete
 * 
 * Replicates all styles from the global .myDealer__categorySelect class
 * (SearchableSelect.css) using styled-components so that every feature
 * using <SearchableDropdown> or <StyledAutocomplete> gets the correct
 * look without importing the legacy global CSS file.
 *
 * Uses && (double ampersand) to increase specificity above MUI's
 * emotion-injected defaults.
 */
export const StyledAutocomplete = styled(Autocomplete)`
  /* ── Common root styles (both outlined & standard) ── */
  && .MuiOutlinedInput-root,
  && .MuiInput-root {
    color: #808080;
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    background-color: #fff !important;
    font-size: 0.523rem;
    min-height: 1.7rem;
    max-height: none;
    padding: 0px;
    border-radius: 0.3rem;
    width: 100% !important;
  }

  /* ── Outlined-variant input (absolute so it stretches over chips) ── */
  && .MuiOutlinedInput-root input {
    font-size: 0.75rem;
    position: absolute;
    width: 100% !important;
  }

  /* ── Standard-variant input (keep in flow) ── */
  && .MuiInput-root input {
    font-size: 0.75rem;
  }

  /* ── Placeholder ── */
  && .MuiAutocomplete-input::placeholder {
    color: #808080;
    font-weight: 400;
    opacity: 1;
  }

  /* ── Custom dropdown arrow (popup indicator ONLY) ── */
  && .MuiAutocomplete-popupIndicator .MuiSvgIcon-root {
    background-image: url(${downArrow});
    background-size: 16px;
    background-repeat: no-repeat;
    background-position: center;
    color: #808080;
    font-size: 0.731rem;
    top: 2px;
    width: 1.5em;
    position: inherit;
  }

  && .MuiAutocomplete-popupIndicator .MuiSvgIcon-root path {
    display: none;
  }

  /* ── Hide chip close icon ── */
  && .MuiAutocomplete-tag svg {
    display: none;
  }

  /* ── Label ── */
  && .MuiFormLabel-root.MuiInputLabel-root {
    top: -8px;
    font-size: 0.75rem;
    color: #2cc26a;
  }
`;
